import { render, staticRenderFns } from "./Handover_customer.vue?vue&type=template&id=ae3933c6&"
import script from "./Handover_customer.vue?vue&type=script&lang=js&"
export * from "./Handover_customer.vue?vue&type=script&lang=js&"
import style0 from "./Handover_customer.vue?vue&type=style&index=0&id=ae3933c6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports